import React from 'react';
import theme from '../../../muiTheme';
import './styles.scss'; 

const AnimatedTick = ({primaryColor, secondaryColor, diameter}) => {

    primaryColor = primaryColor || theme.palette.primary.main; 
    secondaryColor = secondaryColor || 'white'; 
    const height = diameter || '50px';
    const width = height; 

    return (
        <svg 
            className="checkmark" 
            style={{
                '--primary-color': primaryColor, 
                '--secondary-color': secondaryColor, 
                '--height': height, 
                '--width': width
                }}
                xmlns="http://www.w3.org/2000/svg" 
                
                viewBox="0 0 52 52">
            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
        </svg>
    );
}

export default AnimatedTick; 